import urlConfig from "../../config.json";
import { BACKEND_URL } from "../../constants";
import { getCookie } from "../../utils/cookies";
import { axios, configureAxios } from "../../utils/axiosConfig";
import {
  notifyAuthSessionChanged,
  persistAuthUserFields,
} from "../../auth/utils/session";

export const login = async (email, password) => {
  const ROUTE = urlConfig.backend.routes.authentication.login;
  const url = `${BACKEND_URL}${ROUTE}`;
  const reqData = {
    email: email,
    password: password,
  };

  return await axios
    .post(url, reqData)
    .then((res) => {
      if (res.status === 200) {
        persistAuthUserFields(res.data);
        if (getCookie("accessToken")) {
          configureAxios();
          notifyAuthSessionChanged();
          return { res: res.data, error_code: 1 };
        }
        return {
          error_code: 2,
          error_message: "Token is not saved",
        };
      }
      return {
        error_code: 2,
        error_message: "Something went wrong. Please try again later.",
      };
    })
    .catch((error) => {
      const status = error.response?.status;
      const data = error.response?.data;
      const message =
        typeof data?.message === "string" ? data.message : null;
      const contactLinkRequired = Boolean(data?.contact_link_required);

      if (contactLinkRequired && message) {
        return {
          error_code: 3,
          error_message: message,
          contact_link_required: true,
        };
      }

      if (status === 400) {
        return {
          error_code: 2,
          error_message: "Email and Password fields are required",
        };
      }

      if (status === 422) {
        return {
          error_code: 3,
          error_message: message || "Email or Password is incorrect.",
        };
      }

      return {
        error_code: 2,
        error_message: message || error.message || "Request failed",
      };
    });
};
